import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { cardStyle, dotStyle, labelStyle } from './vinExtractionStyles';
import ProcessingSwitch from './ProcessingSwitch';

/** The processing state and its switch, at the top of the modal. */
const SettingsProcessingCard = ({ settings, readOnly, onSettingsChange, onReload }) => {
    const { t } = useTranslation('vinExtraction');

    return (
        <Flex vertical gap={spacing[1]} style={cardStyle}>
            <Flex align="center" gap={spacing[1]}>
                <span style={dotStyle(settings.state)} aria-hidden="true" />
                <span style={labelStyle}>{t('status.processing')}</span>
                <Typography.Text strong>{t(`status.state.${settings.state}`)}</Typography.Text>
            </Flex>
            <ProcessingSwitch
                settings={settings}
                readOnly={readOnly}
                onSettingsChange={onSettingsChange}
                onReload={onReload}
            />
        </Flex>
    );
};

export default SettingsProcessingCard;
